import { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { getDefaultRedirectPath } from "../../../components/ProtectedRoute/ProtectedRoute";

export const StepConfirmation = ({ step, onSuccess }: any) => {
  const [countdown, setCountdown] = useState(5);
  const { session } = useAuth();
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    // Only start timer if session is available and we haven't redirected yet
    if (!session?.user || hasRedirected) return;

    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      // Redirect to user-type-specific route
      const redirectPath = getDefaultRedirectPath(
        //@ts-expect-error
        session.user.system_user_type,
        //@ts-expect-error
        session.user.email,
      );
      setHasRedirected(true);
      window.location.href = redirectPath;
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [session?.user, hasRedirected]); // Re-run if session becomes available

  return (
    <div className="flex w-full flex-col gap-4 py-8">
      <p className="text-2xl font-semibold">Thank you, few more seconds</p>
      <p>
        We are redirecting you to your profile in{" "}
        <span className="font-medium">{countdown}</span> seconds.
      </p>
    </div>
  );
};
